/**
 * SmartOLT descarta en silencio el formulario de ubicación si un texto lleva tildes, eñes,
 * comillas, apóstrofes o '#'. Solo acepta letras sin tilde, números, espacio y . , / ( ) & + -
 * (el mismo criterio que aplica el backend antes de enviar).
 */
const INVALID = /[^A-Za-z0-9 .,/()&+-]/g;

export const ONU_TEXT_ALLOWED_HINT = 'Use letras sin tilde, números y . , / ( ) & + -';

/** Caracteres del texto que SmartOLT no acepta, sin repetir y en orden. */
export const invalidOnuTextChars = (text: string | null | undefined): string[] => [
  ...new Set(String(text ?? '').match(INVALID) ?? []),
];

/** Quita los caracteres que SmartOLT no acepta. */
export const stripInvalidOnuText = (text: string | null | undefined): string =>
  String(text ?? '').replace(INVALID, '');

/** "ñ, #" → texto del error de campo. */
export const invalidOnuTextMessage = (chars: string[]): string =>
  `Carácter no válido: ${chars
    .map((c) => (c === ' ' ? 'espacio' : `"${c}"`))
    .join(', ')}. ${ONU_TEXT_ALLOWED_HINT}.`;
